"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joe = void 0;
exports.joe = {
    router: '0x60aE616a2155Ee3d9A68541Ba4544862310933d4',
    chef: '0xd6a4F121CA35509aF06A0Be99093d08462f53052',
};
